// Shared between Sidebar.tsx's mobile hamburger button and BaseTemplate.tsx's page header.
// They're two independent components - one position:fixed (outside the page's own layout flow),
// one a normal in-flow Box - so nothing keeps their height/top-offset in sync automatically.
// Both must reference these same values, not their own separately-chosen numbers, or they drift
// apart the moment either one's content/styling changes.
export const ACTION_BAR_HEIGHT = "48px";
export const ACTION_BAR_MARGIN = "8px";

// Fixed icon-rail width for Sidebar.tsx - the sidebar never expands, this is its only width.
// Notably slimmer than the previous organically-sized ~60px rail (12px padding + 20px icon +
// 12px padding + 8px margin/side), but with enough breathing room around the icon to not feel
// cramped (an initial 36px/4px-padding pass read as too tight):
//   NavItem HStack: p={2} (8px/side) + Icon boxSize 20px + p={2} (8px/side) = 36px content
//   NavItem HStack: m={1} (4px/side) outer margin                           = +8px
//   => 44px (down from ~60px). Change only in lockstep with NavItem's own m/p/icon sizing in
//   Sidebar.tsx, or the rail will clip content / have dead slack.
export const SIDEBAR_WIDTH = "44px";

// Minimum per-item hit target height (icon row height) - generous tap/click target per sidebar
// best practice (~48-56px). A HEIGHT constraint, independent of the width above.
export const SIDEBAR_ITEM_HEIGHT = "48px";
